import AiVideoCard from './AiVideoCard';
import AiImageCard from './AiImageCard';

export default function AiSectionGallery({ videos = [], images = [] }) {
  return (
    <div className="ai-gallery">
      {videos.map((v) => (
        <AiVideoCard key={v.src} src={v.src} fileName={v.fileName} />
      ))}
      {images.map((img) => (
        <AiImageCard key={img.src} src={img.src} fileName={img.fileName} />
      ))}
    </div>
  );
}

